import { truncateSelectedValues, formatSelectionsArray } from './utils'
import { coloursData } from '@cinch-nx/data-search'

export const getFormattedColour = (colourSelections: string[] = []) =>
  truncateSelectedValues(formatSelectionsArray(colourSelections, coloursData))
